// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b7Jy","label":"styles_label__2rrmN"};